import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class IdleUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('General.enableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'IdleUIState');
        this.onExecuted?.();
    }

    getName(): string {
        return 'IdleUIAct';
    }
}